import { render, staticRenderFns } from "./CardsCategoria.vue?vue&type=template&id=3371f6de&"
import script from "./CardsCategoria.vue?vue&type=script&lang=ts&"
export * from "./CardsCategoria.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports